import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import PropTypes from 'prop-types';

const PlanSlider = ({ items, sliderSettings, wrapperClass = '' }) => {
  const [sliderKey, setSliderKey] = useState(0);

  useEffect(() => {
    let resizeTimer;
    const handleResize = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        setSliderKey(prev => prev + 1);
      }, 150);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      clearTimeout(resizeTimer);
    };
  }, []);

  if (!items || items.length === 0) { return null; }
  return (
    <div className={wrapperClass}>
      {items.length <= 3 ? (
        <section className="plans-carousel-row">
          {items}
        </section>
      ) : (
        <Slider key={sliderKey} {...sliderSettings}>
          {items}
        </Slider>
      )}
    </div>
  );
};

PlanSlider.propTypes = {
  items: PropTypes.array.isRequired,
  sliderSettings: PropTypes.object.isRequired,
  wrapperClass: PropTypes.string,
  flexGap: PropTypes.string,
};

export default PlanSlider;
